// Constants.
import * as DataSourcesConstants from 'constants/DataSourcesConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  categories: [],
  errorMessage: '',
};

export default function datasourcesCategories(state = initialState, action = {}) {
  switch (action.type) {
    case DataSourcesConstants.LOAD_DATASOURCES_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case DataSourcesConstants.LOAD_DATASOURCES_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        categories: action.categories,
      };
    case DataSourcesConstants.LOAD_DATASOURCES_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        categories: initialState.categories,
        errorMessage: action.message,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        categories: initialState.categories,
        errorMessage: '',
      };
    default:
      return state;
  }
}
